import "./loading.css";
import React from "react";

const Loading = () => {
	return (
		<div className="spinner">
			<div className="lds-roller">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>

			<div>Loading...</div>
		</div>
	);
};

export default Loading;
